import { render, staticRenderFns } from "./digeriskodu.vue?vue&type=template&id=5ec63b48&"
import script from "./digeriskodu.vue?vue&type=script&lang=js&"
export * from "./digeriskodu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports